import { styled } from "@mui/material";
import { HiOutlinePlusCircle } from "react-icons/hi";

import { Button } from "../../../../../../../../../components/Form";

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));

export const PlusIcon = styled(HiOutlinePlusCircle)(() => ({
  marginRight: "8px",
}));

export const FileInput = styled("input")(() => ({
  display: "none",
}));
